import { urlSaveConsoleLog } from "../components/URLlist/urlList";

export const saveConsoleLog = (data: string) => {
	try {
		fetch(urlSaveConsoleLog, {
			credentials: "include",
			method: "post",
			headers: { "Content-Type": "text/plain" },
			body: data,
		});
	} catch (error) {}
};
